import { render, staticRenderFns } from "./helpcenter_search.vue?vue&type=template&id=4f9c3d80&scoped=true&"
import script from "./helpcenter_search.vue?vue&type=script&lang=js&"
export * from "./helpcenter_search.vue?vue&type=script&lang=js&"
import style0 from "./helpcenter_search.vue?vue&type=style&index=0&id=4f9c3d80&lang=scss&scoped=true&"
import style1 from "./helpcenter_search.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c3d80",
  null
  
)

export default component.exports